// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class ErrorHandlerService {

//   constructor() { }
// }

// Import necessary Angular modules
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';  // Assuming ToastrService for showing notifications
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private toastr: ToastrService, private router: Router) { }

  public checkForError(error: HttpErrorResponse,from: string): void {
    console.log('Call from:');
    console.log(from);
    console.trace();

    // if (error.status === 0) {
    //   // Network errors or blocked by browser/CORS policy
    //   this.toastr.error('No existe conexión con el servidor', 'Error de conexión');
    // } else 
    if (error.status === 403) {
      // Session expired or unauthorized access
      this.toastr.error('La sesión expiró', 'Tiempo de sesión expirado');
      // Here, you might also navigate to the login page or refresh the session
      // this.router.navigate(['/login']);
      localStorage.clear();
      this.router.navigate(['/']);
    } else {
      // Generic error handling
      this.toastr.error('Error desconocido, contacte con soporte', 'Error en el servidor!');
      console.log(error);
      this.router.navigate(['/']);
    }
  }
}
